import { render } from "./qrCode.vue?vue&type=template&id=24065404&scoped=true"
const script = {}

import "./qrCode.vue?vue&type=style&index=0&id=24065404&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24065404"]])

export default __exports__